import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const Loader = ({ onComplete }) => {
  const containerRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    // Animation Logic
    const ctx = gsap.context(() => {
      gsap.to(ringRef.current, {
        rotation: 360,
        duration: 8,
        ease: "none",
        repeat: -1
      });

      const tl = gsap.timeline({
        delay: 2.5,
        onComplete: () => {
          if (onComplete) onComplete();
          gsap.to(containerRef.current, { opacity: 0, duration: 0.2 });
        }
      });

      tl.to(ringRef.current, {
        scale: 15,
        opacity: 0,
        duration: 1.2,
        ease: "power4.in",
      });
    }, containerRef);

    return () => {
      ctx.revert();
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [onComplete]);

  return (
    <div ref={containerRef} className="fixed inset-0 bg-[#ffffff] z-[9999] flex flex-col items-center justify-center overflow-hidden font-sans">
      
      {/* Large Circular Ring Text - Adjusted for Mobile */}
      <div ref={ringRef} className="relative w-[300px] h-[300px] sm:w-[500px] sm:h-[500px] md:w-[800px] md:h-[800px] flex items-center justify-center">
        <svg className="w-full h-full" viewBox="0 0 500 500" aria-hidden="true">
          <defs>
            <path id="circlePath" d="M 250,250 m -180,0 a 180,180 0 1,1 360,0 a 180,180 0 1,1 -360,0" />
          </defs>
          <text className="text-[16px] font-bold uppercase fill-black tracking-[0.06em]">
            <textPath href="#circlePath" startOffset="0%" textLength="1110" lengthAdjust="spacing">
              SALES LEADERSHIP • CUSTOMER SUCCESS • TEAM DEVELOPMENT • OPERATIONAL EXCELLENCE •
            </textPath>
          </text>
        </svg>
        <div className="absolute inset-0 m-auto w-[65%] h-[65%] border border-gray-300 rounded-full"></div>
      </div>

      <div className="absolute bottom-8 left-0 w-full text-center md:text-left md:left-8 text-[10px] md:text-xs font-mono text-gray-500 uppercase tracking-widest">
        Preparing Katherine's Portfolio...
      </div>
    </div>
  );
};

export default Loader;